import React from "react";
import userProfile from "../../assets/img/userProfile.svg";
import { IconMarin } from '../../views/popup/SvgSprite';
import { withRouter } from "react-router-dom";
import { Modal } from "antd";
import _authService from "modules/AuthService";
import ConfirmPopup from "../../views/popup/ConfirmPopup";
import {
    USER_NAME, PROFILE_URL, Last_LOGIN_DATETIME
} from "constants/constants";
import moment from 'moment';

class BiometricHeader extends React.Component {
    constructor(props) {
        super(props);
        this.changePasswordModalRef = React.createRef();
        this.profileModalRef = React.createRef();
        this.analysisId = this.props.match.params.analysisId;
        this.state = {
            visible: false,
            ConfirmPopup: false,
            ChangePass: false,
            showProfileModal: false,
            username: localStorage[USER_NAME],
            profileURL: localStorage[PROFILE_URL],
            lastLoginDate: localStorage[Last_LOGIN_DATETIME]
        };
    }

    componentDidMount() {
        this.setState({
            lastLoginDate: moment(localStorage[Last_LOGIN_DATETIME]).calendar(),
            profileURL: localStorage[PROFILE_URL]
        });
    }

    ChangePass(ChangePass) {
        this.setState({ ChangePass });
        if (!ChangePass) {
            this.changePasswordModalRef.current.handleCancel();
        }
    }

    ConfirmPopup(ConfirmPopup) {
        this.setState({ ConfirmPopup });
    }

    logout = () => {
        _authService.logoutBiometricAdmin();
    };

    goToHome = () => {
        _authService.logoutBiometricAdmin();
    };


    render() {
        return (
            <header className="adminHeaderMain">
                <div className="container-fluid1">
                    <nav className="navbar  navbar-expand-lg justify-content-between navbar-light p-0">
                        <div className="d-flex">
                            {this.props.location.pathname != "/candidateList" ? (
                                <div className="homeHeader pr-3 border-right">
                                    <span>
                                        <IconMarin width={'70px'} iconName="logo" fill="#fff" class="iconMain" />
                                    </span>
                                </div>
                            ) : (
                                ""
                            )}

                        </div>

                        <div id="navbarSupportedContent" className=" justify-content-end">
                            <ul className="nav navbar-nav align-items-center justify-content-end">
                                <li className="nav-item userInfo dropdown mr-sm-3">
                                    <a
                                        className="nav-link pt-0 pb-0 dropdown-toggle d-flex align-items-center"
                                        href="#"
                                        id="navbardrop"
                                        data-toggle="dropdown"
                                    >
                                        <span className="userIconWrap mr-1 d-inline-flex align-items-center justify-content-center">
                                            <img src={this.state.profileURL ? this.state.profileURL : userProfile} height="25px" />
                                        </span>
                                        <span className="ml-2">
                                            <label className="mb-0 useName">
                                                {this.state.username}
                                                <IconMarin iconName="down-arrow" fill="#fff" class="icon" />
                                            </label>
                                            <small>
                                                {"Role: Admin"}
                                            </small>
                                        </span>
                                    </a>
                                    <div className="topheaderdropdown dropdown-menu dropdown-menu-right ">
                                        <div className="dropdown-divider m-0"></div>
                                        <div
                                            className=" dropdown-item p-2"
                                            onClick={() => this.ConfirmPopup(true)}
                                            role="button"
                                            tabIndex={0}
                                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { this.ConfirmPopup(true); } }}
                                        >
                                            <IconMarin iconName="logout-icon" fill="#797979" class="icon mr-2" />
                                            Logout
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>

                <Modal
                    centered={true}
                    width={400}
                    className="modelPopAnt ent-modal-sm admin-home"
                    visible={this.state.ConfirmPopup}
                    onCancel={() => this.ConfirmPopup(false)}
                    footer={false}
                >
                    <ConfirmPopup
                        onCancel={() => this.ConfirmPopup(false)}
                        onOk={this.logout}
                        message="Are you sure, you want to logout?"
                    />
                </Modal>
            </header>
        );
    }
}

export default withRouter(BiometricHeader);